window.jsPDF = window.jspdf.jsPDF;
angular.module('Itao.IndicatorMap').controller('ExportPreviewModalController', ['$scope', '$timeout', '$window', '$uibModalInstance', 'data', function ($scope, $timeout, $window, $uibModalInstance, data) {
  'use strict';
  // Apply categories to scope for select field
  $scope.export = data;
  $scope.exportConfig = {};
  var grids = $scope.export.config.gridContainer.grids;
  var gridItem = grids[Object.keys(grids)[0]];

  var widgetContainer;
  var previewContainer;
  // var gridItemElement;

  if (gridItem) {
    $scope.gridConfig = gridItem;
    $scope.widgetConfig = gridItem.widget ? gridItem.widget : {};
    $scope.exportGridContainer = angular.copy($scope.export.config.gridContainer);
  }

  // defaults
  $scope.exportConfig.source = "<b>Quelle (Datenauswertung):</b> Ländermonitor Frühkindliche Bildungssysteme, www.laendermonitor.de";
  $scope.exportConfig.exportFormat = 'png';

  $timeout(function () {
    widgetContainer = angular.element(document.querySelector("#widgetContent"));
    previewContainer = angular.element(document.querySelector("#exportWidgetPreview"));
    widgetContainer.children().appendTo(previewContainer);

    $scope.widgetConfig.displayValues = true;
    $scope.widgetConfig.displayValues = false;
  });

  /**
   * Closes the modal window and returns the data for the new bookmark
   */
  $scope.exportPreview = function (exportConfig) {
    if ($scope.widgetConfig) {
      $scope.widgetConfig.displayValues = false;
    }

    console.log("exportConfig", exportConfig);

    if (exportConfig.exportFormat === 'pdf') {
      convertHtmlToPdf();
    } else {
      convertHtmlToPng();
    }
  };

  function convertHtmlToPng() {
    html2canvas(document.querySelector("#exportContent"), {
      letterRendering: 1
    }).then(function (canvas) {
      var imgData = canvas.toDataURL('image/png');

      // Create a link element and trigger a download
      var downloadLink = document.createElement('a');
      downloadLink.href = imgData;
      downloadLink.download = 'diagramm_export.png';
      downloadLink.click();

      previewContainer.children().appendTo(widgetContainer);
      $uibModalInstance.close();
    });
  }

  function convertHtmlToPdf() {
    html2canvas(document.querySelector("#exportContent"), {
      letterRendering: 1
    }).then(function (canvas) {
      var imgData = canvas.toDataURL('image/png');
      generatePDF(imgData);
    });
  }

  function generatePDF(imageData) {
    var pdf = new window.jsPDF('landscape', 'mm', 'a4'); // Portrait orientation, millimeters, A4 size
    var imgWidth = pdf.internal.pageSize.getWidth();
    var imgHeight = pdf.internal.pageSize.getHeight();

    // Set margins (adjust as needed)
    var topMargin = 0;
    var leftMargin = 10;

    // Add image with margins
    pdf.addImage(imageData, 'PNG', leftMargin, topMargin, imgWidth - 20, imgHeight - 20);

    var blob = new Blob([pdf.output('blob')], {type: 'application/pdf'});

    var downloadLink = $window.document.createElement('a');
    downloadLink.href = $window.URL.createObjectURL(blob);
    downloadLink.download = 'diagramm_export.pdf';

    // Trigger the download
    downloadLink.click();

    previewContainer.children().appendTo(widgetContainer);
    $uibModalInstance.close();
  }

  /**
   * Closes the creation modal window
   */
  $scope.close = function () {
    previewContainer.children().appendTo(widgetContainer);
    if ($scope.widgetConfig) {
      $scope.widgetConfig.displayValues = false;
      $scope.widgetConfig.withoutArea = false;
    }
    $uibModalInstance.dismiss('cancel');
  };

  $scope.$watch('widgetConfig.withoutArea', function () {
    var numberOfRects = jQuery('g.feature rect').length;
    $scope.canShowValues = numberOfRects < 65;
  });
}]);
